import React from "react";
import { useCmsSlider } from "../../context/CmsSliderContext";

export default function Section2() {
  const { setIsOpenSlider } = useCmsSlider();

  const images = [
    "/assets/pic1-media.jpg",
    "/assets/pic2-media.jpg",
    "/assets/pic3-media.jpg",
    "/assets/pic4-media.jpg",
    "/assets/pic5-media.jpg",
    "/assets/pic6-media.jpg",
    "/assets/pic7-media.jpg",
    "/assets/pic8-media.jpg",
    "/assets/pic9-media.jpg",
    "/assets/pic10-media.jpg",
    "/assets/pic11-media.jpg",
    "/assets/pic12-media.jpg",
    "/assets/pic13-media.jpg",
    "/assets/pic14-media.jpg",
    "/assets/pic15-media.jpg",
    "/assets/pic16-media.jpg",
    "/assets/pic17-media.jpg",
    "/assets/pic18-media.jpg",
    "/assets/pic19-media.jpg",
    "/assets/pic20-media.jpg",
    "/assets/pic21-media.jpg",
  ];
  return (
    <>
      <div className="container-1280 w-full py-[35px] px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] hidden lg:block overflow-hidden">
        <div className="flex mb-2 overflow-hidden gap-x-2">
          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic1-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:0, slides:images });
            }}
          >
          </img>

          <img
            className="block w-[50%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic2-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:1, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic3-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:2, slides:images });
            }}
          ></img>
        </div>

        <div className="flex mb-2 overflow-hidden gap-x-2">
          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic4-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:3, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic5-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:4, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic6-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:5, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic7-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:6, slides:images });
            }}
          ></img>
        </div>

        <div className="flex mb-2 overflow-hidden gap-x-2">
          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic8-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:7, slides:images });
            }}
          ></img>

          <img
            className="block w-[50%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic9-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:8, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic10-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:9, slides:images });
            }}
          ></img>
        </div>

        <div className="flex mb-2 overflow-hidden gap-x-2">
          <img
            className="block w-[50%] h-[565px] object-cover cursor-pointer"
            src="/assets/pic11-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:10, slides:images });
            }}
          ></img>

          <div className="flex-col w-[50%] overflow-hidden">
            <div className="flex mb-2 gap-x-2">
              <img
                className="block w-[49.4%] h-[278px] object-cover cursor-pointer"
                src="/assets/pic12-media.jpg"
                onClick={() => {
                  setIsOpenSlider({ show: true, index:11, slides:images });
                }}
              ></img>
              <img
                className="block h-[278px] w-[49.4%] object-cover cursor-pointer"
                src="/assets/pic13-media.jpg"
                onClick={() => {
                  setIsOpenSlider({ show: true, index:12, slides:images });
                }}
              ></img>
            </div>
            <img
              className="block object-cover h-[278px] w-full cursor-pointer"
              src="/assets/pic14-media.jpg"
              onClick={() => {
                setIsOpenSlider({ show: true, index:13, slides:images });
              }}
            ></img>
          </div>
        </div>

        <div className="flex mb-2 gap-x-2">
          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic15-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:14, slides:images });
            }}
          ></img>

          <img
            className="block w-[50%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic16-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:15, slides:images });
            }}
          ></img>

          <img
            className="block w-[25%] h-[278px] object-cover cursor-pointer"
            src="/assets/pic17-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:16, slides:images });
            }}
          ></img>
        </div>

        <div className="flex mb-2 gap-x-2">
          <div className="flex w-[50%] gap-x-2">
            <div className="flex-col">
              <img
                className="block w-full mb-2 h-[278px] object-cover cursor-pointer"
                src="/assets/pic18-media.jpg"
                onClick={() => {
                  setIsOpenSlider({ show: true, index:17, slides:images });
                }}
              ></img>

              <img
                className="block w-full h-[278px] object-cover cursor-pointer"
                src="/assets/pic19-media.jpg"
                onClick={() => {
                  setIsOpenSlider({ show: true, index:18, slides:images });
                }}
              ></img>
            </div>

            <img
              className="block w-[50%] h-full object-cover cursor-pointer"
              src="/assets/pic20-media.jpg"
              onClick={() => {
                setIsOpenSlider({ show: true, index:19, slides:images });
              }}
            ></img>
          </div>

          <img
            className="block w-[50%] h-[565px] object-cover cursor-pointer"
            src="/assets/pic21-media.jpg"
            onClick={() => {
              setIsOpenSlider({ show: true, index:20, slides:images });
            }}
          ></img>
        </div>
      </div>

      <div className="w-full py-[35px] px-[15px] mx-auto md:w-[750px] block lg:hidden">
        <div className="flex flex-wrap gap-x-2 gap-y-2">
          {images.map((image, index) => (
            <img
              key={index}
              className="block object-cover w-full xs:w-[49%]"
              src={image}
              alt={`Image ${index + 1}`}
              onClick={() => {
                setIsOpenSlider({ show: true, index, slides:images });
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}
